import { useParams } from '@tanstack/react-router'
import {
  MemberPreviewCoursePage,
  MemberPreviewLessonPage,
  MemberPreviewOfferPage,
  MemberPreviewPage,
} from './MemberPreviewPage'

function usePreviewParams() {
  const { productId = '', lessonId } = useParams({ strict: false })
  return { productId, lessonId }
}

export function MemberPreviewRoutePage() {
  const { productId } = usePreviewParams()
  return <MemberPreviewPage productId={productId} />
}

export function MemberPreviewCourseRoutePage() {
  const { productId } = usePreviewParams()
  return <MemberPreviewCoursePage productId={productId} />
}

export function MemberPreviewOfferRoutePage() {
  const { productId } = usePreviewParams()
  return <MemberPreviewOfferPage productId={productId} />
}

export function MemberPreviewLessonRoutePage() {
  const { productId, lessonId = '' } = usePreviewParams()
  return <MemberPreviewLessonPage productId={productId} lessonId={lessonId} />
}
